import { inlineAtomNode } from '#src/tiptap/nodes/shared.ts'

export const AddTimelineNoteButtonNode = inlineAtomNode(
  'add-timeline-note-button',
  'button',
  { display: { isDisplay: true } }
)
